import _ from 'lodash';

// constants
import { getRequest, postRequest } from '../../Common/network-call';
import {
  DOWNLOAD_AGENDA_URI,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';

export const FETCH_SCHEDULES_DATES = 'FETCH_SCHEDULES_DATES';
export const MY_AGENDA_LIST = 'MY_AGENDA_LIST';
export const CURRENT_DATE_AGENDA = 'CURRENT_DATE_AGENDA';

export const fetchScheduleDates = (
  session,
  extra = { apptabId: null },
  callback = null
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(isactive=1)AND(apptabid=${extra?.apptabId})`
  );
  let orderby = 'scheduledate';
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.scheduledates}?include_count=true&filter=(${filter})&order=${orderby}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: FETCH_SCHEDULES_DATES,
          payload: { data: data.resource, count: data.meta.count }
        });
        callback &&
          callback({
            success: 1,
            result: { data: data.resource, count: data.meta.count }
          });
      },
      error => {
        callback && callback({ success: 0, error: error });
      }
    );
  };
};

export function clearScheduleDates(obj) {
  return dispatch => {
    dispatch({
      type: FETCH_SCHEDULES_DATES,
      payload: obj
    });
  };
}

export const fetchAgenda = (
  session,
  extra = { fetchBookmark: true },
  callback = null
) => {
  const bkmrkFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=schedule))`
  );
  const bkmrkUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.bookmarks}?filter=${bkmrkFilter}`;

  const rsvpFilter = encodeURI(
    `((eventid=${session.eventid})AND(appuserid=${session.userid}))`
  );
  const rsvpUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.sessionRsvp}?filter=${rsvpFilter}`;

  return dispatch => {
    getRequest(
      bkmrkUrl,
      session,
      dispatch,
      bookmarkRes => {
        getRequest(
          rsvpUrl,
          session,
          dispatch,
          rsvpRes => {
            let workingList = _.concat(
              ...(extra?.fetchBookmark || true ? bookmarkRes?.resource : []),
              rsvpRes.resource
            );

            if (workingList.length > 0) {
              let idStr = [];
              _.map(workingList, (item, index) => {
                let idToAdd = item.typeid || item.sessionid; // Choose appropriate id
                idStr.push(idToAdd);
              });
              idStr = _.uniq(idStr);
              idStr = idStr.join(',');

              let agendaFilter = encodeURI(
                `((eventid=${session.eventid})AND(sessionid IN (${idStr})))`
              );
              let related = `colordetails,speaker_by_sessionspeakers,speaker_by_speakerid&speaker_by_speakerid.fields=${FIELDS.speaker.minInfo}&speaker_by_sessionspeakers.fields=${FIELDS.speaker.minInfo}`;
              let orderby = FETCH_ORDERS.session;
              let agendaFetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.session}?include_count=true&related=${related}&filter=${agendaFilter}&order=${orderby}`;
              getRequest(
                agendaFetchUrl,
                session,
                dispatch,
                data => {
                  dispatch({
                    type: MY_AGENDA_LIST,
                    payload: { resource: data.resource }
                  });
                  callback && callback({ success: 1, resource: data.resource });
                },
                error => {}
              );
            } else {
              dispatch({
                type: MY_AGENDA_LIST,
                payload: { resource: workingList }
              });
              callback && callback({ success: 1, resource: workingList });
            }
          },
          rsvpError => {}
        );
      },
      error => {
        callback && callback({ success: 0, message: error });
      }
    );
  };
};

export function clearAgenda(obj) {
  return dispatch => {
    dispatch({
      type: MY_AGENDA_LIST,
      payload: obj
    });
  };
}

export function currentDateAgenda(value) {
  return dispatch => {
    dispatch({
      type: CURRENT_DATE_AGENDA,
      payload: { data: value, count: value.length }
    });
  };
}

export const downloadAgenda = (session, apptabid, callback) => {
  let url = `${session?.instance_url}${SCRIPT_URI_ADDON}${SCRIPTS.customScript.endpoint}`;
  let body = _.cloneDeep(SCRIPTS.customScript.payload);
  body.eventid = session.eventid;
  body.appuserid = session.userid;
  body.apptabid = apptabid;

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      res => {
        callback({ success: true, data: res });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};
